import { render, staticRenderFns } from "./TreeBreadcrumb.vue?vue&type=template&id=60e95f92&"
import script from "./TreeBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TreeBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports